/*
 *
 * announcementReducer reducer
 *
 */

import {Map} from 'immutable';
import {OPEN_BAR, CLOSE_BAR, OPEN_DIALOG, CLOSE_DIALOG, SET_IMAGE_LINK} from './constants';

const initialState = new Map({
    openBar: false,
    openDialog: false,
    id: null,
    name: null,
    content: null,
    file: null,
    link: null,
});

function announcementReducer(state = initialState, {type, meta, payload}) {
    switch (type) {
        case OPEN_BAR:
            return state
                .set('openBar', true)
                .set('id', payload.id)
                .set('name', payload.name)
                .set('content', payload.content)
                .set('date', payload.date)
                .set('file', payload.file)
                .set('link', null)

        case CLOSE_BAR:
            return state
                .set('openBar', false)

        case OPEN_DIALOG:
            return state
                .set('openDialog', true)

        case CLOSE_DIALOG:
            return state
                .set('openDialog', false)

        case SET_IMAGE_LINK:
            return state
                .set('link', payload.link)

        default:
            return state;
    }
}

export default announcementReducer;
